"use client";

import Image from "next/image";

const siteName = process.env.NEXT_PUBLIC_SITE_NAME || "TurtleTrack";

export function Logo({ variant = "full" }: { variant?: "full" | "icon" }) {
  if (variant === "icon") {
    return (
      <div className="h-7 w-7 overflow-hidden rounded-md">
        <Image
          src="/logo/wmi-icon.png"
          alt={siteName}
          width={28}
          height={28}
          className="h-full w-full object-contain"
          priority
        />
      </div>
    );
  }

  return (
    <div className="relative flex items-center justify-center h-12">
      <Image
        src="/logo/The Wildlife.jpg"
        alt={siteName}
        width={160}
        height={48}
        className="h-auto w-auto max-w-[160px]"
        priority
      />
    </div>
  );
}
